import { render, staticRenderFns } from "./TranslatableCollection.vue?vue&type=template&id=ab289e34&"
import script from "./TranslatableCollection.vue?vue&type=script&lang=js&"
export * from "./TranslatableCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports